import axios from 'axios';

export default {
    state: {
        departments: null,
    },
    getters: {
        getDepartments(state) {
            return state.departments
        }
    },
    mutations: {
        setDepartments(state, data) {
            return state.departments = data
        }
    },
    actions: {
        departmentsRequest(context) {
            return axios.post('/api/branches/branch')
                .then(res => {
                    context.commit('setDepartments', res.data[0])
                })
        }
    }
}